import { render, staticRenderFns } from "./group.vue?vue&type=template&id=309ba75c&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"
import style0 from "./group.vue?vue&type=style&index=0&id=309ba75c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ba75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309ba75c')) {
      api.createRecord('309ba75c', component.options)
    } else {
      api.reload('309ba75c', component.options)
    }
    module.hot.accept("./group.vue?vue&type=template&id=309ba75c&scoped=true", function () {
      api.rerender('309ba75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/group.vue"
export default component.exports